import React from 'react';
import Box from '@mui/material/Box';
import { Tooltip } from '@mui/material';

/**
 * Priority to palette token, in severity order. The tokens are scheme-aware (see
 * PRIORITY in app/tokens.js); an unknown priority falls back to `normal`.
 */
const PRIORITY_TOKENS = {
  low: 'priorityLow',
  normal: 'priorityNormal',
  elevated: 'priorityElevated',
  critical: 'priorityCritical',
};

/**
 * @param {Object} props
 * @param {string} [props.priority='normal']
 */
export default function Priority({ priority = 'normal' }) {
  const key = String(priority).toLowerCase();
  const token = PRIORITY_TOKENS[key] || PRIORITY_TOKENS.normal;

  return (
    <Tooltip title={`${priority.toUpperCase()} PRIORITY`}>
      <Box
        aria-label={`${priority} priority`}
        sx={{
          width: '10px',
          height: '55px',
          borderRadius: '1px',
          backgroundColor: `status.${token}`,
        }}
      />
    </Tooltip>
  );
}
